/*
 * The measurements table in the size guide (snippets/jc-size-guide.liquid).
 *
 * One row per size this product has, in the order of the size buttons on the
 * page, with the factory measurements from #jc-size-table (chest, length,
 * sleeve and shoulder, flat, in cm). Children's sizes come first under their
 * own heading, adults under theirs. A size the factory sheet does not list
 * (XS, 6XL) shows a dash instead of a number, never a guess.
 *
 * With data-all (the size page, LICHT-BESLUITEN L32) there is no product:
 * every size in #jc-size-table is a row, in the order of the table, which is
 * the shop's own order (scripts/size-table-sync.py writes it that way).
 */
if (!customElements.get('size-guide-table')) {
  class SizeGuideTable extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('[data-rows]');
      let table;
      try {
        table = JSON.parse(document.getElementById('jc-size-table').textContent);
      } catch (error) {
        this.hidden = true;
        return;
      }
      const sizes = this.hasAttribute('data-all') ? this.allSizes(table) : this.productSizes();
      const groups = [
        { name: this.dataset.kids, rows: table.kind || {} },
        { name: this.dataset.adults, rows: table.volwassen || {} },
      ];
      const cm = (value) => (value === null || value === undefined ? '–' : String(value).replace('.0', '').replace('.', ','));
      let count = 0;
      groups.forEach((group) => {
        const own = sizes.filter((size) => Object.prototype.hasOwnProperty.call(group.rows, size.value));
        if (!own.length) return;
        if (groups.every((g) => sizes.some((size) => Object.prototype.hasOwnProperty.call(g.rows, size.value)))) {
          const head = document.createElement('tr');
          head.className = 'size-guide__group';
          head.innerHTML = `<th scope="rowgroup" colspan="5">${group.name}</th>`;
          body.appendChild(head);
        }
        own.forEach((size) => {
          const row = group.rows[size.value] || {};
          const tr = document.createElement('tr');
          tr.dataset.size = size.value;
          tr.innerHTML = `<th scope="row">${size.label}</th><td>${cm(row.borst)}</td><td>${cm(row.lengte)}</td><td>${cm(row.mouw)}</td><td>${cm(row.schouder)}</td>`;
          body.appendChild(tr);
          count += 1;
        });
      });
      this.hidden = count === 0;
    }

    /** The size buttons of the product on the page, as the customer reads them. */
    productSizes() {
      const scope = document.querySelector('.product-info') || document;
      return [...scope.querySelectorAll('input.opt-btn')].map((input) => ({
        value: input.value,
        label: (scope.querySelector(`label[for="${input.id}"]`)?.textContent || input.value).trim(),
      }));
    }

    /** Every size of the table, children first, as on the product page. */
    allSizes(table) {
      return [...Object.keys(table.kind || {}), ...Object.keys(table.volwassen || {})].map((value) => ({ value, label: value }));
    }
  }

  customElements.define('size-guide-table', SizeGuideTable);
}
